import React, { createContext, useContext, useRef } from "react";
import { toPng } from "html-to-image";
import JSZip from "jszip";
import { saveAs } from "file-saver";

const SnapshotContext = createContext();

export const useSnapshot = () => useContext(SnapshotContext);

export const SnapshotProvider = ({ children }) => {
  const snapshotRefs = useRef({});

  const addSnapshotRef = (key, ref) => {
    snapshotRefs.current[key] = ref;
  };

  const removeSnapshotRef = () => {
    snapshotRefs.current = {}; // Clears all previous refs
  };

  const UniqueremoveSnapshotRef = () => {
    snapshotRefs.current = {}; // Clears all previous refs
  };

  const takeSnapshot = async (key) => {
    const element = snapshotRefs.current[key];
    if (element) {
      try {
        const dataUrl = await toPng(element);
        const link = document.createElement("a");
        link.href = dataUrl;
        link.download = `${key}.png`;
        link.click();
      } catch (error) {
        console.error("Snapshot failed:", error);
      }
    } else {
      console.error("No element found for key:", key);
    }
  };

  


// const takeMultipleSnapshots = async (keys) => {
//     try {
//       const zip = new JSZip();

//       for (const key of keys) {
//         const element = snapshotRefs.current[key];
//         if (element) {
//           const dataUrl = await toPng(element);
//           const base64Data = dataUrl.split(",")[1]; // Extract base64 data from the Data URL
//           zip.file(`${key}.png`, base64Data, { base64: true }); // Add image to ZIP file
//         } else {
//           console.warn(`No element found for key: ${key}`);
//         }
//       }

//       // Generate the ZIP file and trigger the download
//       const zipBlob = await zip.generateAsync({ type: "blob" });
//       saveAs(zipBlob, "snapshots.zip");
//     } catch (error) {
//       console.error("Snapshots failed:", error);
//     }
//   };

const takeMultipleSnapshots = async (keys) => {
  // console.log("key of snapshot component::",keys);
  
  try {
      if (!Array.isArray(keys)) {
          console.error("Invalid argument: keys should be an array");
          return;
      }

      const zip = new JSZip();

      for (const key of keys) {
          const element = snapshotRefs.current[key];
          if (element) {
              const dataUrl = await toPng(element);
              const base64Data = dataUrl.split(",")[1]; // Extract base64 data
              zip.file(`${key}.png`, base64Data, { base64: true });
          } else {
              console.warn(`No element found for key: ${key}`);
          }
      }

      // Generate and download ZIP file
      if (Object.keys(zip.files).length > 0) {
          const zipBlob = await zip.generateAsync({ type: "blob" });
          saveAs(zipBlob, "snapshots.zip");
      } else {
          console.warn("No valid snapshots to download.");
      }
  } catch (error) {
      console.error("Snapshots failed:", error);
  }
};

  return (
    <SnapshotContext.Provider value={{ addSnapshotRef,removeSnapshotRef,UniqueremoveSnapshotRef, takeSnapshot, takeMultipleSnapshots }}>
      {children}
    </SnapshotContext.Provider>
  );
};
